<script>
    import { Link } from 'svelte-navigator'
</script>

<!-- Begin of logo -->
<div class="logo-wrapper">
    <Link to='/'>
        <h2 class="logo">
            <span class="logo-img">
                    <img class="light-logo" src="/img/logo.png" alt="Logo">
            </span>
            <!-- <span class="logo-text show-for-medium-up">
                <span class="title">Global Shipping Watch</span>
                <span class="desc">Agency</span>
            </span> -->
        </h2>
    </Link>
</div>
<!-- End of logo -->